import { useCallback, useEffect, useState } from "react"


export const useDebounce = (useCb: () => void, deps: any[] = [], timeout?: number) => {
    const [timer, setTimer] = useState<any>()

    useEffect(() => {
        clearTimeout(timer)

        setTimer(setTimeout(useCb, timeout || 500))
    }, deps)
}